import * as z from "zod/v4";

export const getUpsellProductAnalytics = {
  name: "getUpsellProductAnalytics" as const,
  input: z.object({ startDate: z.date(), endDate: z.date() }),
  output: z.object({
    productAnalytics: z.array(
      z.object({
        productId: z.string(),
        productTitle: z.string(),
        offered: z.number(),
        accepted: z.number(),
        conversionRate: z.number(),
        revenue: z.number(),
        imageUrl: z.string().nullable(),
      }),
    ),
  }),
};

export type GetUpsellProductAnalyticsOutput = z.infer<
  typeof getUpsellProductAnalytics.output
>;
